export const validControlsMarvinArray = [
  "textbox",
//   "password",
  "textarea",
  "datepick",
//   "listbox",
  "combo",
//   "radio",
//   "checkbox",
//   "toggle",
//   "picklist",
//   "button",
//   "captcha",
//   "sheet",
//   "tile",
//   "doclist"
"form",
"frame",
];
